module.exports = __webpack_public_path__ + "static/media/loading.d0756313.gif";